import request from '@/utils/httpClient'

// 登记收款
export function changeFee(data: any) {
  return request({
    url: 'received',
    method: 'post',
    data
  })
}

// 登记退款
export function refundFee(data: any) {
  return request({
    url: 'received/refund',
    method: 'post',
    data
  })
}
